module.exports = __webpack_public_path__ + "static/vinarmani-6cdefa361b7cff498c00a55c27ee899e.jpg";